"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeName = void 0;
var normalizeName = function (name) {
    return name
        .toLowerCase()
        .replace(/(\W+|_)/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '') || '';
};
exports.normalizeName = normalizeName;
//# sourceMappingURL=normalizeName.js.map